import React from 'react';
import {VaccineConsentFormState} from '../ScheduleAppointment/ScheduleAppointment';
import {Vaccine} from '@shared/services/service-mappers/AppointmentSchedulingMapper';
import ShingrixConsentForm from './ShingrixConsentForm/ShingrixConsentForm';
import FluConsentForm from './FluConsentForm/FluConsentForm';
import {VACCINE_INFO_KEY_MAPPER} from '@shared/constants/Mapping';

interface ConsentFormState extends VaccineConsentFormState {
  updateConsentFormState: React.Dispatch<
    React.SetStateAction<VaccineConsentFormState>
  >;
  selectedVaccine: Vaccine | null;
}
const ConsentForm = (props: ConsentFormState): JSX.Element => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!props.selectedVaccine) return <React.Fragment />;
  const vaccineInfoKey = props.selectedVaccine.vaccine_info_key;
  if (vaccineInfoKey === VACCINE_INFO_KEY_MAPPER.SHINGRIX) {
    return (
      <ShingrixConsentForm
        updateConsentFormState={props.updateConsentFormState}
        {...props[VACCINE_INFO_KEY_MAPPER.SHINGRIX]}
        selectedVaccine={props.selectedVaccine}
      />
    );
  }
  if (vaccineInfoKey === VACCINE_INFO_KEY_MAPPER.FLUARIX_QUADRIVALENT) {
    return (
      <FluConsentForm
        {...props[VACCINE_INFO_KEY_MAPPER.FLUARIX_QUADRIVALENT]}
        updateConsentFormState={props.updateConsentFormState}
        selectedVaccine={props.selectedVaccine}
      />
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
};

export default ConsentForm;
